import { all } from 'redux-saga/effects';
import addMeasurementSaga from './AddMeasurement/AddMeasurement.saga';

export const measurementRootSaga = function* rootSaga() {
    yield all([
        addMeasurementSaga(),
    ]);
}
